<template>
	<div>
		<AccessRestrictedButton v-for="(button, buttonKey) in elements" :key="buttonKey"
								style-class="default_group_btn_style"
								:button-class="value === button ? activeButtonClass : inactiveButtonClass"
								:button-name-key="button.translationKey"
								:permission="button.permission"
								:no-access-display-type="button.noAccessDisplayType"
								:show-error="showError"
								@click="activateElement(button)"
		></AccessRestrictedButton>
	</div>
</template>

<script>
import AccessRestrictedBaseComponentGroup
	from "@/components/templates/common/permissions/AccessRestrictedBaseComponentGroup";
import AccessRestrictedButton from "@/components/templates/common/permissions/AccessRestrictedButton";

export default {
	components: { AccessRestrictedButton },
	extends: AccessRestrictedBaseComponentGroup,
	props: {
		activeButtonClass: { type: String, default: "md-primary" },
		inactiveButtonClass: { type: String, default: "md-white" },
	}
};
</script>

<style lang="scss" scoped>
.default_group_btn_style {
	min-width: 100px;
	width: 15%;
	font-size: 14px !important;
	font-weight: 500 !important;
}
</style>